// import React from 'react';
// import { Box, Container } from '@mui/material';
// import background from '../../utilities/dummy_assets/background.png'
// import logo from '../../utilities/dummy_assets/logo.png'

// //TODO: Sizing Issue
// const RegisterPage = () => {
//   return (
//     <>
//     <Box
//       sx={{
//         width: '100vw',
//         height: '100vh',
//         backgroundImage: `url(${background})`,
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//       }}
//     >
//       {/* Position the HeaderToggle at the top right, overlaying other content */}
//       <Box sx={{
//         position: 'fixed',
//         top: 0, // Align to the top
//         right: 40, // Align to the right
//         zIndex: 1201, // Make sure it's above other content
//       }}>
//         <HeaderToggle />
//       </Box>

//       <Box sx={{
//           position: 'fixed',
//           top: 16, // Adjust the value to match the image's position
//           left: 16, // Adjust the value to match the image's position
//           zIndex: 1201, // Ensures the logo is above other content
//         }}>
//           <img src={logo} alt="Logo" />
//         </Box>

//       {/* Main content of the page, laid out with flex */}
//       <Box sx={{ display: 'flex', height: '100vh' }}>
//         <Container sx={{ flex: 2, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
//           <RegistrationForm />
//         </Container>
//       </Box>
//       </Box>
//     </>
//   );
// };

// export default RegisterPage;

import React, { useState } from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import Logo from '../../utilities/dummy_assets/MBF_Logo.png';
import mapITlogo from '../../utilities/dummy_assets/mapITlogo.png';
import AdminRegistrationForm from '../../components/admin/register/AdminRegistrationForm';
import OrganizationalRegistrationForm from '../../components/admin/register/OrganizationalRegistrationForm';
import { ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Paper } from '@mui/material';
import { Grid } from '@mui/material';
// import { Button } from "@mui/material";

const RegisterPage = () => {
  const navigate = useNavigate();
  const [bgAdmin, setBgAdmin] = useState('#212121');
  const [bgOrgAdmin, setBgOrgAdmin] = useState('212121');

  const handleAdminClick = () => {
    setBgOrgAdmin('white');
    setBgAdmin('#212121');
  };

  const handleOrgAdminClick = () => {
    setBgOrgAdmin('#212121');
    setBgAdmin('white');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: '#F7F7F7',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      {/* Top Left Logo */}
      <Box
        sx={{
          position: 'absolute',
          top: '12px',
          left: '50px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <img
          src={Logo}
          alt="MBF Logo"
          style={{ height: '69px', width: '159px' }}
        />
      </Box>
      {/* Top Right Link */}
      <Box
        sx={{
          position: 'absolute',
          top: '12px',
          right: '50px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Typography
          component="span"
          onClick={() =>
            (window.location.href = 'https://tinkerspace.mis.mapit.ai/')
          }
          sx={{
            color: '#0062CC',
            cursor: 'pointer',
            textDecoration: 'underline',
            fontSize: '16px',
            fontWeight: 500,
          }}
        >
          Go to Student Site
        </Typography>
      </Box>
      `{' '}
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(to bottom, #ffffff, #1e88e5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          px: 2,
        }}
      >
        {/* Admin Link */}
        <Box position="absolute" top={16} right={24}>
          <Link href="#" underline="hover" color="primary">
            Go to admin site
          </Link>
        </Box>

        {/* Main Card */}
        <Paper
          elevation={3}
          sx={{
            p: 4,
            width: '100%',
            maxWidth: 600,
            borderRadius: 3,
            textAlign: 'center',
          }}
        >
          <Typography variant="h6" gutterBottom>
            Set Your Profile Photo
          </Typography>

          <Box
            sx={{
              backgroundColor: '#fff8c4',
              color: '#b28900',
              py: 1,
              px: 2,
              mb: 3,
              fontSize: 14,
              borderRadius: 1,
              fontWeight: 500,
            }}
          >
            Keep these things in mind while clicking your picture
          </Box>

          {/* Posture Section */}
          <Box textAlign="left" mb={3}>
            <Typography variant="subtitle1" fontWeight={600}>
              Posture:
            </Typography>
            <Grid container spacing={2} mt={1}>
              {[
                { label: 'Correct ✓', color: 'green', img: '/correct.png' },
                { label: 'Tilt ✗', color: 'red', img: '/tilt.png' },
                { label: 'Side ✗', color: 'red', img: '/side.png' },
                { label: 'Raise ✗', color: 'red', img: '/raise.png' },
                { label: 'Bow ✗', color: 'red', img: '/bow.png' },
              ].map((item, i) => (
                <Grid item xs={2.4} key={i} textAlign="center">
                  <Box
                    component="img"
                    src={item.img}
                    alt={item.label}
                    sx={{ width: 50, height: 50, objectFit: 'contain' }}
                  />
                  <Typography
                    variant="caption"
                    sx={{ color: item.color, fontWeight: 500 }}
                  >
                    {item.label}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Size Section */}
          <Box textAlign="left" mb={4}>
            <Typography variant="subtitle1" fontWeight={600}>
              Size:
            </Typography>
            <Grid container spacing={2} mt={1}>
              {[
                {
                  label: 'Correct ✓',
                  color: 'green',
                  img: '/correct_size.png',
                },
                { label: 'Too Close ✗', color: 'red', img: '/too_close.png' },
                { label: 'Too Far ✗', color: 'red', img: '/too_far.png' },
              ].map((item, i) => (
                <Grid item xs={4} key={i} textAlign="center">
                  <Box
                    component="img"
                    src={item.img}
                    alt={item.label}
                    sx={{ width: 60, height: 60, objectFit: 'contain' }}
                  />
                  <Typography
                    variant="caption"
                    sx={{ color: item.color, fontWeight: 500 }}
                  >
                    {item.label}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Buttons */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Link href="#" underline="hover" color="primary">
              ‹ Back
            </Link>
            <Button variant="contained" color="primary">
              + Open Camera
            </Button>
          </Box>

          {/* Footer */}
          <Box mt={4}>
            <Typography variant="caption" color="textSecondary">
              Powered by{' '}
              <Typography component="span" color="secondary" fontWeight={600}>
                apIT.ai
              </Typography>
            </Typography>
          </Box>
        </Paper>
      </Box>
      `{/* Registration Form Section */}
      {/* <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          flexGrow: 1,
        }}
      > */}
      {/* Toggle Between Admin and Organizational Registration */}
      {/* <Box sx={{ ml:'180px', display: "flex", alignSelf: "start", height:'61px', }}>
          <Button
            variant="outlined"
            onClick={handleAdminClick}
            sx={{ */}
      {/* fontSize: "18px",
              padding: "16px 24px",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "0.75rem 0 0 0.75rem",
              border: "1px solid #5C5C5C",
              backgroundColor: bgAdmin,
              color: bgAdmin === "#212121" ? "white" : "#212121",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: bgAdmin === "#212121" ? "#212121" : "#f0f0f0",
              },
            }}
          >
            Admin
          </Button>
          <Button
            variant="outlined"
            onClick={handleOrgAdminClick}
            sx={{ */}
      {/* padding: "16px 24px",
              fontSize: "18px",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "0 0.75rem 0.75rem 0",
              border: "1px solid #5C5C5C",
              backgroundColor: bgOrgAdmin,
              color: bgOrgAdmin === "#212121" ? "white" : "#212121",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: bgOrgAdmin === "#212121" ? "#212121" : "#f0f0f0",
              },
            }}
          >
            Organizational
          </Button>
        </Box> */}
      {/* Render the Registration Form based on the selected tab */}
      {/* {bgAdmin === "#212121" ? (
          <AdminRegistrationForm />
        ) : (
          <OrganizationalRegistrationForm />
        )}
      </Container> */}
      {/* Footer with Bottom Middle Logo */}
      <Box
        sx={{
          position: 'absolute',
          bottom: '20px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          // flexDirection: "column",
        }}
      >
        <Typography sx={{ fontWeight: 400, fontSize: '24px' }}>
          Powered by
        </Typography>
        <img src={mapITlogo} alt="mapIT Logo" style={{ height: '40px' }} />
        <Typography
          sx={{
            fontWeight: 400,
            fontFamily: 'Times New Roman',
            fontSize: '14px',
            marginTop: '8px',
            ml: 1,
          }}
        >
          mapIT.ai
        </Typography>
      </Box>
      <ToastContainer />
    </Box>
  );
};

export default RegisterPage;
